import { Component, Input } from '@angular/core';

@Component({
    selector: 'ui-lookup-option',
    templateUrl: './lookup-option.component.html',
    styleUrls: ['./lookup-option.component.less']
})
export class LookupOptionComponent {
    @Input() option: any;
    @Input() query: string;
    @Input() isOnWatchlist = false;

    // noImagePath: string = CommonConfig.noPhotoUrl;

    getGuestImageSrc(mediaId: string): string {
        return  'sss';
        // return mediaId ? `${ApiConfig.File.fileUrl}/${mediaId}` : this.noImagePath;
    }

}
